import SlideshowView from './SlideshowView';

export default SlideshowView;
